import {
  errEmptySeries,
  errUnexpectedExportersNumber,
  errUnexpectedFormattersNumber,
  errUnexpectedHeadersLength,
  errUnexpectedHeadersType,
  errUnexpectedRowType,
  errUnexpectedSeriesType,
} from "@/app/errors/errors.graph_data"
import {
  ExportOutput,
  Exporter,
  FormatOutput,
  Formatter,
} from "@/app/types/formatters"

export class GraphData {
  name: string
  asOfLabel: string | null
  series: any[][]
  headers: any[]
  private _name: string
  private _formatters: Formatter[]
  private _exporters: Exporter[]

  constructor({
    name = "NoName",
    series,
    headers,
    formatters,
    exporters,
    asOfLabel = "NoDate",
  }) {
    // use this name for logging
    this._name = name ? `GraphData [${name}]` : "GraphData"
    this.asOfLabel = asOfLabel

    // ensure that series is any[][]
    if (!Array.isArray(series))
      errUnexpectedSeriesType(this._name, typeof series)

    // check if series is not empty
    if (series.length == 0) errEmptySeries(this._name)

    // check all rows types
    series.forEach((row, idx) => {
      if (!Array.isArray(row)) errUnexpectedRowType(this._name, idx, typeof row)
    })

    // check all rows lengths
    const numColumns = series[0].length
    // series.forEach((row, idx) => {
    //   if (row.length != numColumns)
    //     errUnexpectedRowLength(this._name, idx, numColumns, row.length)
    // })
    this.series = series

    // ensure that headers.length matches the number of columns
    if (!Array.isArray(headers))
      errUnexpectedHeadersType(this._name, typeof headers)

    if (headers.length != numColumns)
      errUnexpectedHeadersLength(this._name, numColumns, headers.length)
    this.headers = headers

    // validate formatters
    const isValidFormatters =
      formatters == null ||
      (Array.isArray(formatters) &&
        (formatters.length == 1 || formatters.length >= numColumns))

    if (!isValidFormatters)
      errUnexpectedFormattersNumber(this._name, numColumns, formatters?.length)
    this._formatters = formatters

    // validate exporters
    const isValidExporters =
      exporters == null ||
      (Array.isArray(exporters) &&
        (exporters.length == 1 || exporters.length >= numColumns))

    if (!isValidExporters)
      errUnexpectedExportersNumber(this._name, numColumns, exporters?.length)
    this._exporters = exporters
  }

  private _format(
    col: any,
    colIdx: number,
    isHeader: boolean = false
  ): FormatOutput {
    if (this._formatters == null) return col
    if (this._formatters.length == 1 && this._formatters[0])
      return this._formatters[0](col, colIdx, isHeader)
    if (colIdx < this._formatters.length && this._formatters[colIdx])
      return this._formatters[colIdx](col, colIdx, isHeader)
    return col
  }
  formatCol(col: any, colIdx: number): FormatOutput {
    return this._format(col, colIdx, false)
  }
  formatHeader(head: any, headIdx: number): FormatOutput {
    return this._format(head, headIdx, true)
  }

  private _export(
    col: any,
    colIdx: number,
    isHeader: boolean = false
  ): ExportOutput {
    if (this._exporters == null) return col
    if (this._exporters.length == 1 && this._exporters[0])
      return this._exporters[0](col, colIdx, isHeader)
    if (colIdx < this._exporters.length && this._exporters[colIdx])
      return this._exporters[colIdx](col, colIdx, isHeader)
    return col
  }
  exportCol(col: any, colIdx: number): ExportOutput {
    return this._export(col, colIdx, false)
  }
  exportHeader(head: any, headIdx: number): ExportOutput {
    return this._export(head, headIdx, true)
  }
}
